import { render, staticRenderFns } from "./token_expire.vue?vue&type=template&id=a37c970e"
import script from "./token_expire.vue?vue&type=script&lang=js"
export * from "./token_expire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports